import { render, staticRenderFns } from "./AutorizacionesIndex.vue?vue&type=template&id=2482765e"
import script from "./AutorizacionesIndex.vue?vue&type=script&lang=js"
export * from "./AutorizacionesIndex.vue?vue&type=script&lang=js"
import style0 from "./AutorizacionesIndex.vue?vue&type=style&index=0&id=2482765e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports